'use client';

import { useRouter } from 'next/navigation';
import { Gift, Percent, Megaphone, User } from 'lucide-react';

interface BottomProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export default function Bottom(props: BottomProps) {
  const router = useRouter();
  const { activeTab, setActiveTab } = props

  const onRoute = (tab: string) => {
    setActiveTab(tab)
    router.push(`/?tab=${encodeURIComponent(tab)}`);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 max-w-md mx-auto shadow-lg">
      <div className="grid grid-cols-4">
        <button 
          onClick={() => onRoute('home')} 
          className={`flex flex-col items-center py-2 ${activeTab === 'home' ? 'bg-orange-500 text-white' : 'bg-orange-100 text-orange-600'}`}
        >
          <Gift className="w-6 h-6 mb-0.5" />
          <span className="text-[10px] leading-tight">รางวัล</span>
          <span className="text-[10px] leading-tight">/ สิทธิพิเศษ</span>
        </button>
        
        <button 
          onClick={() => onRoute('promotions')} 
          className={`flex flex-col items-center py-2 ${activeTab === 'promotions' ? 'bg-orange-500 text-white' : 'bg-orange-100 text-orange-600'}`}
        >
          <Percent className="w-6 h-6 mb-1" />
          <span className="text-[11px] font-medium">โปรโมชั่น</span>
        </button>
        
        <button 
          onClick={() => onRoute('news')} 
          className={`flex flex-col items-center py-2 ${activeTab === 'news' ? 'bg-orange-500 text-white' : 'bg-orange-100 text-orange-600'}`}
        >
          <Megaphone className="w-6 h-6 mb-0.5" />
          <span className="text-[10px] leading-tight">ข่าว</span>
          <span className="text-[10px] leading-tight">และกิจกรรม</span>
        </button>
        
        <button 
          onClick={() => onRoute('profile')} 
          className={`flex flex-col items-center py-2 ${activeTab === 'profile' ? 'bg-orange-500 text-white' : 'bg-orange-100 text-orange-600'}`}
        >
          <User className="w-6 h-6 mb-0.5" />
          <span className="text-[10px] leading-tight">ประวัติ</span>
          <span className="text-[10px] leading-tight">/ บัญชี</span>
        </button>
      </div>
    </div>
  );
}
